function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 136 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M67.867 0C30.387 0 0 30.387 0 67.875c0 29.987 19.446 55.425 46.417 64.404 3.396.621 4.633-1.475 4.633-3.275 0-1.608-.058-5.879-.092-11.541-18.879 4.1-22.862-9.1-22.862-9.1-3.088-7.838-7.538-9.926-7.538-9.926-6.162-4.212.467-4.129.467-4.129 6.813.484 10.396 6.996 10.396 6.996 6.054 10.371 15.887 7.375 19.754 5.642.617-4.388 2.367-7.379 4.308-9.075-15.07-1.713-30.916-7.538-30.916-33.546 0-7.408 2.646-13.467 6.987-18.212-.7-1.717-3.029-8.617.663-17.963 0 0 5.7-1.825 18.666 6.958 5.413-1.504 11.221-2.258 16.992-2.283 5.763.025 11.571.779 16.992 2.283 12.958-8.783 18.646-6.958 18.646-6.958 3.704 9.346 1.375 16.246.674 17.963 4.35 4.745 6.98 10.804 6.98 18.212 0 26.075-15.871 31.813-30.992 33.492 2.438 2.096 4.608 6.237 4.608 12.571 0 9.07-.083 16.391-.083 18.616 0 1.817 1.221 3.929 4.667 3.267 26.95-8.996 46.379-34.417 46.379-64.396C135.746 30.388 105.354 0 67.867 0",
    style: {
      fill: "#181717"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github-icon.c5c87ed7dbde7b49df2e17529f49a96d.svg";
export { ForwardRef as ReactComponent };